var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcCloseS = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M22.707 10.707a1 1 0 0 0-1.414-1.414L16 14.586l-5.293-5.293a1 1 0 0 0-1.414 1.414L14.586 16l-5.293 5.293a1 1 0 1 0 1.414 1.414L16 17.414l5.293 5.293a1 1 0 0 0 1.414-1.414L17.414 16z",
  clipRule: "evenodd"
})));
export default SvgIcCloseS;